(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('smoother-multiplier', {
            parent: 'entity',
            url: '/smoother-multiplier',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.smootherMultiplier.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multipliers.html',
                    controller: 'SmootherMultiplierController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smootherMultiplier');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('smoother-multiplier-detail', {
            parent: 'entity',
            url: '/smoother-multiplier/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.smootherMultiplier.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-detail.html',
                    controller: 'SmootherMultiplierDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smootherMultiplier');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SmootherMultiplier', function($stateParams, SmootherMultiplier) {
                    return SmootherMultiplier.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('smoother-multiplier.new', {
            parent: 'smoother-multiplier',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-dialog.html',
                    controller: 'SmootherMultiplierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('smoother-multiplier', null, { reload: true });
                }, function() {
                    $state.go('smoother-multiplier');
                });
            }]
        })
        .state('smoother-multiplier.edit', {
            parent: 'smoother-multiplier',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-dialog.html',
                    controller: 'SmootherMultiplierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SmootherMultiplier', function(SmootherMultiplier) {
                            return SmootherMultiplier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('smoother-multiplier', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('smoother-multiplier.delete', {
            parent: 'smoother-multiplier',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/smoother-multiplier/smoother-multiplier-delete-dialog.html',
                    controller: 'SmootherMultiplierDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SmootherMultiplier', function(SmootherMultiplier) {
                            return SmootherMultiplier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('smoother-multiplier', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
